export default __webpack_public_path__ + "static/media/Defenders_Landing_LE.2789f40b.jpg";